import { useEffect, useState } from "react";
import { Blocks } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { HoteOutil } from "./HoteOutil";

export const useOutilsDock = () => {
  const [l, setL] = useState([]);
  useEffect(() => { api.get("/outils/epingles", { params: { lieu: "dock" } }).then((r) => setL(r.data)).catch(() => setL([])); }, []);
  return l;
};

export const FenetreOutil = ({ outil, onClose }) => (
  <Dialog open={!!outil} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="at-popover max-w-[calc(100vw-1rem)] sm:max-w-2xl p-3" data-testid="dock-tool-dialog">
      <DialogTitle className="px-2 pt-1">{outil?.nom}</DialogTitle>
      {outil && <HoteOutil outil={outil} hauteur={Math.min(620, window.innerHeight - 140)} />}
    </DialogContent>
  </Dialog>
);

export const BoutonOutilDock = ({ outil, onOuvrir, mobile }) => (
  <button type="button" onClick={() => onOuvrir(outil)} aria-label={outil.nom} title={outil.nom} data-testid={`${mobile ? "sheet" : "dock"}-tool-${outil.id}`}
    className={mobile ? "at-soft flex flex-col items-center gap-2 py-4 min-h-[76px] text-sm font-semibold px-1 text-center" : "at-icon-btn w-12 h-12"}>
    <Blocks size={20} strokeWidth={1.9} />{mobile && <span className="line-clamp-2 text-xs">{outil.nom}</span>}
  </button>
);
